// extracted by mini-css-extract-plugin
var _1 = "Button-module_btn_danger__L6D6gP";
var _2 = "Button-module_btn_default__XLr1yL";
var _3 = "Button-module_btn_icon__zZcPCi";
var _4 = "Button-module_btn_primary__mgpqAw";
var _5 = "Button-module_btn_secondary__EvreU1";
var _6 = "Button-module_loading__pP9hVz";
export { _1 as "btn_danger", _2 as "btn_default", _3 as "btn_icon", _4 as "btn_primary", _5 as "btn_secondary", _6 as "loading" }
